import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

/** short vibrations: the plugin in the shells, navigator.vibrate on the web (Android only) */
export class Buzz {
  enabled = true;
  private native = Capacitor.isNativePlatform();

  private web(pattern: number | number[]): void {
    try {
      navigator.vibrate?.(pattern);
    } catch {
      /* unsupported */
    }
  }

  light(): void {
    if (!this.enabled) return;
    if (this.native) void Haptics.impact({ style: ImpactStyle.Light });
    else this.web(10);
  }

  heavy(): void {
    if (!this.enabled) return;
    if (this.native) void Haptics.impact({ style: ImpactStyle.Heavy });
    else this.web(30);
  }

  error(): void {
    if (!this.enabled) return;
    if (this.native) void Haptics.notification({ type: NotificationType.Error });
    else this.web([40, 40, 40]);
  }

  success(): void {
    if (!this.enabled) return;
    if (this.native) void Haptics.notification({ type: NotificationType.Success });
    else this.web([15, 30, 15]);
  }
}
